@if (!editMode) {
  <div>
    {{ data | number: '.3' }}
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="example-full-width">
    <input formControlName="{{ fieldConfig.name }}" type="number" matInput value="{{ data }}" />
  </mat-form-field>
}
